// Extracts a numeric amount in CZK from price labels like:
//   "3 990 Kč"        → 3990
//   "od 1 990 Kč"     → 1990 (with from=true)
//   "indiv. kalkulace"→ null
//   "nezávazně"       → null
//   "15 Kč"           → 15 (unit-based, treated as base)
//   "dle kalkulace"   → null

export function parsePriceLabel(label) {
  if (!label || typeof label !== "string") return { amount: null, from: false };
  const lower = label.toLowerCase();
  if (/indiv|kalkulace|nezávazně|nezavazne|v ceně|individuálně|individuálne/.test(lower)) {
    return { amount: null, from: false };
  }
  const from = /\bod\b/.test(lower);
  // grab first number with optional thousand spaces / non-breaking spaces
  const match = label.replace(/\u00a0/g, " ").match(/(\d[\d\s]*(?:[.,]\d+)?)\s*K[čč]/i);
  if (!match) return { amount: null, from };
  const num = parseFloat(match[1].replace(/\s+/g, "").replace(",", "."));
  if (Number.isNaN(num)) return { amount: null, from };
  return { amount: num, from };
}

export function formatCzk(amount) {
  if (amount == null) return "—";
  return new Intl.NumberFormat("cs-CZ", { style: "currency", currency: "CZK", maximumFractionDigits: 0 }).format(amount);
}
